import { useI18n } from '../contexts/I18nContext';

/**
 * Skip-to-main-content link.
 * Visually hidden until keyboard-focused (Tab on page load).
 * Targets `#main-content` which each page should set on its <main>.
 */
const LABEL = {
  en: 'Skip to main content',
  es: 'Saltar al contenido principal',
  pt: 'Pular para o conte\u00fado principal',
};

export default function SkipLink() {
  const { lang } = useI18n();
  return (
    <a href="#main-content" className="skip-to-content" data-testid="skip-link">
      {LABEL[lang] || LABEL.en}
    </a>
  );
}
